import api from '../api/client'

const cadastroPublicoConfigService = {
  getConfig: async (organizadorId) => {
    const response = await api.get(`/configuracoes/cadastro-publico/organizadores/${organizadorId}/cadastro-publico-config`)
    return response.data
  },

  saveConfig: async (organizadorId, config) => {
    const response = await api.put(`/configuracoes/cadastro-publico/organizadores/${organizadorId}/cadastro-publico-config`, config)
    return response.data
  },

  saveLinkCadastro: async (organizadorId, linkCadastro) => {
    const response = await api.put(`/configuracoes/cadastro-publico/organizadores/${organizadorId}/link-cadastro`, {
      link_cadastro: linkCadastro,
    })
    return response.data
  },

  uploadBanner: async (organizadorId, file) => {
    const formData = new FormData()
    formData.append('arquivo', file)
    const response = await api.post(
      `/configuracoes/cadastro-publico/organizadores/${organizadorId}/banner-upload`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return response.data
  },
}

export default cadastroPublicoConfigService
